// src/shaders/particles/vertex.glsl

uniform float uTime;
uniform float uTravelDistance;
uniform float uBoundsStart;
uniform float uBoundsEnd;

attribute float aSize;
attribute float aAnimationSpeed;
attribute float aAnimationOffset; 
attribute float aTextureIndex;
attribute float aMoveSpeed; // Nova velocitat

varying float vTextureIndex;

void main(){
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    
    // Moviment cap a les X negatives. Perquè no surtin mai de la seva àrea vital, apliquem Wrap a l'estil cinta de córrer!
    float targetX = modelPosition.x - (uTravelDistance * aMoveSpeed);
    float range = uBoundsEnd - uBoundsStart;
    
    // El GLSL mod permet ciclar el moviment sense parar dintre del passadís.
    float wrappedX = mod((targetX - uBoundsStart), range);
    modelPosition.x = uBoundsStart + wrappedX;
    
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    float lifeDuration = aAnimationOffset; 
    float time = mod(uTime + aAnimationSpeed, lifeDuration);
    float progress = time / lifeDuration;
    float scale = sin(progress * 3.14159); 

    gl_PointSize = aSize * scale * 4.0; 
    gl_PointSize *= (10.0 / -viewPosition.z);

    gl_Position = projectedPosition;

    vTextureIndex = aTextureIndex;
}